export default callBack => {
  return (...rest) =>
    callBack(...rest).catch(error => {
      console.log('error:', error);
      throw error;
    });
};
